import apiService from 'services/apiService';
const baseUrl = `${window._env_.PLATFORM_API_DOMAIN}`;

const getEventsAccess = () => {
  const url = `${baseUrl}/v1/events/access`;
  return apiService.get(url);
};

const newSSEEvents = (token) => new EventSource(`${baseUrl}/v1/events?token=${token}`);

export { getEventsAccess, newSSEEvents };
